import { useSelector } from 'react-redux';

const usePrintMode = () => useSelector(state => state?.print);

export default usePrintMode;
